import { MatterType } from '@/matter/store/schemas'
import type { MatterRead, MatterReadForTable } from '@/matter/store/schemas'

/**
 * Returns true if the matter is the sample matter created for a new user.
 */
export function isSampleMatter(matter: MatterRead | MatterReadForTable | null | undefined): boolean {
  return matter?.type === MatterType.SAMPLE
}
